<h2 mat-dialog-title>
  {{ 'EMAIL_BUILDER.CONTENT_SUGGESTION.PROMPT' | translate }}
</h2>
<mat-dialog-content>
  <glxy-form-field>
    <glxy-label>
      {{ 'EMAIL_BUILDER.CONTENT_SUGGESTION.INSTRUCTIONS' | translate }}
    </glxy-label>
    <textarea
      #promptInput
      matInput
      placeholder="{{ 'EMAIL_BUILDER.CONTENT_SUGGESTION.PROMPT_PLACEHOLDER' | translate }}"
      [(ngModel)]="promptText"
      maxlength="400"
    ></textarea>
  </glxy-form-field>
  <div class="generate-content-btn-wrapper">
    <button
      mat-flat-button
      color="primary"
      (click)="suggestMessage(promptText)"
      data-action="suggestions-clicked-generate"
      [disabled]="loading$ | async"
    >
      <glxy-button-loading-indicator [isLoading]="loading$ | async">
        {{ 'EMAIL_BUILDER.CONTENT_SUGGESTION.GENERATE_CONTENT' | translate }}
      </glxy-button-loading-indicator>
    </button>
  </div>
  <glxy-form-field>
    <glxy-label>
      {{ 'EMAIL_BUILDER.CONTENT_SUGGESTION.GENERATED_CONTENT' | translate }}
    </glxy-label>
    <textarea
      #contentInput
      matInput
      rows="10"
      placeholder="{{ 'EMAIL_BUILDER.CONTENT_SUGGESTION.GENERATED_CONTENT_PLACEHOLDER' | translate }}"
      [(ngModel)]="contentText"
    ></textarea>
  </glxy-form-field>
</mat-dialog-content>
<mat-dialog-actions class="use-content-actions">
  <button mat-stroked-button mat-dialog-close (click)="closeDialog()">
    {{ 'EMAIL_BUILDER.CONTENT_SUGGESTION.CANCEL' | translate }}
  </button>
  <button
    mat-flat-button
    color="accent"
    (click)="useSuggestedMessage(contentText)"
    [disabled]="contentText === ''"
    data-action="suggestions-clicked-use"
  >
    {{ 'EMAIL_BUILDER.CONTENT_SUGGESTION.USE_CONTENT' | translate }}
  </button>
</mat-dialog-actions>
